import styled from 'styled-components';
import {
  px2rem,
  gridContainer,
  setGridColumns,
  mq,
  getGridColumns
} from '../../../stylesheets/tools';

const StyledNewsletterTeaser = styled.section`
  padding: ${px2rem('140px')} 0 ${px2rem('60px')} 0;
  background-color: ${props => props.theme.globalTheme.primary};
  clip-path: polygon(25% 0%, 100% 10%, 100% 100%, 0 100%, 0 14%);

  ${mq('xl')} {
    clip-path: polygon(10% 0, 96% 12%, 100% 45%, 100% 100%, 15% 100%, -5% 64%, 3% 10%);
    padding: ${px2rem('140px')} 0 ${px2rem('80px')} 0;
  }

  .newsletter__container {
    ${gridContainer()}
    ${setGridColumns('1fr', 1)}
    gap: 25px;

    ${mq('m')} {
      gap: 40px;
    }

    ${mq('xl')} {
      ${setGridColumns('1fr', 3)}
    }

    .newsletter__form {
      ${getGridColumns([1, 1], { xl: [2, 4] })}

      ${mq('xl')} {
        padding-left: 40px;
      }
    }
  }
`;

export default StyledNewsletterTeaser;
